import FadeIn from '@/components/commonComponents/fadeIn';
import SFullPage from './style.module.scss';
import classnames from 'classnames';

interface FullPageLayoutProps {
  /** 模块标题 */
  title: string;
  /** 背景颜色 */
  background?: string;
  children: JSX.Element;
  className?: string;
}

/**
 * full page 模块专用布局
 * 目前主要用于硬件产品页（SoundMatrix、LiveEncoder、6dof）
 */
const FullPageLayout = ({
  title,
  children,
  background,
  className,
}: FullPageLayoutProps) => {
  return (
    <div
      className={classnames({
        [SFullPage['section']]: true,
        [className]: !!className,
      })}
      style={{ background }}
    >
      <FadeIn>
        <div className={SFullPage['title']}>{title}</div>
      </FadeIn>
      <FadeIn>{children}</FadeIn>
    </div>
  );
};

export default FullPageLayout;
